import React from 'react'
import {
  Button,
  Container,
  Col,
  Row,
  Table
} from 'reactstrap'
import { ListItem } from '.'
import { IgtLoader } from 'Atoms'

const CloudContactsList = ({ modelList, filterDepartmentSelect, filterBusinessUnitSelect, onChangeFilter, isLoading }) => {
  return (
    <Container fluid>
      <Row>
        <Col lg={{ size: 6, offset: 3}}>
          <h1 className="text-center">Cloud Contacts Table</h1>
        </Col>
        <Col lg="3">
          <Button href="/auth/create/cloud_contacts">Add New Cloud Contact</Button>
        </Col>
      </Row>
      <Row>
        <Col lg="12">
          {
            isLoading ?
            <IgtLoader isLoading={isLoading}/>
            :
            <Table hover>
              <thead className='sticky-header'>
                <tr>
                <th>Terminated (yes/no)</th>
                  <th>Name</th>
                  <th>Email</th>
                </tr>
              </thead>
              <tbody>
                {
                  modelList && modelList.map((contact, i) => {
                    return (
                      <ListItem
                        modelListItem={contact}
                        key={i}
                        index={i}
                      />
                    )
                  })
                }
              </tbody>
            </Table>
          }
        </Col>
      </Row>
    </Container>
  )
}

export default CloudContactsList